var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"no-body":""}},[_c('b-tabs',{attrs:{"small":"","card":""}},[_c('edit-travel-policy')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }